// The backend derives a file's extension from contentFile.getName(), so every
// captured blob has to be wrapped in a File carrying one of these names.
/** Kept well clear of S3 key and dbresource path limits. */
export var MAX_ATTACHMENT_FILENAME_LENGTH = 100;
var EXTENSION = '.jpg';
var shotSuffix = function (shotIndex) { return (shotIndex > 0 ? "-" + (shotIndex + 1) : ''); };
var toFileName = function (stem, shotIndex) {
    var suffix = shotSuffix(shotIndex);
    var budget = MAX_ATTACHMENT_FILENAME_LENGTH - suffix.length - EXTENSION.length;
    return "" + stem.slice(0, Math.max(budget, 0)) + suffix + EXTENSION;
};
/** Joins whole ids with commas up to `budget` chars; dropped ids become a `+N` marker. */
var joinIdsWithinBudget = function (ids, budget) {
    if (budget <= 0)
        return '';
    var all = ids.join(',');
    if (all.length <= budget)
        return all;
    for (var kept = ids.length - 1; kept > 0; kept -= 1) {
        var candidate = ids.slice(0, kept).join(',') + "+" + (ids.length - kept);
        if (candidate.length <= budget)
            return candidate;
    }
    var marker = "+" + ids.length;
    return marker.length <= budget ? marker : '';
};
export var buildPackagePhotoName = function (shipmentId, packageSeqId, shotIndex) {
    if (shotIndex === void 0) { shotIndex = 0; }
    return toFileName("shipment-" + shipmentId + "-package-" + packageSeqId, shotIndex);
};
/** Uses the operator-facing containerSeqNum, not the containerId. */
export var buildContainerPhotoName = function (shipmentId, containerSeqNum, shotIndex) {
    if (shotIndex === void 0) { shotIndex = 0; }
    return toFileName("shipment-" + shipmentId + "-container-" + containerSeqNum, shotIndex);
};
export var buildShipmentPhotoName = function (shipmentId, shotIndex) {
    if (shotIndex === void 0) { shotIndex = 0; }
    return toFileName("shipment-" + shipmentId, shotIndex);
};
export var buildReceivedAssetPhotoName = function (shipmentId, assetIds, shotIndex) {
    if (shotIndex === void 0) { shotIndex = 0; }
    var ids = assetIds.filter(function (id) { return !!id; });
    var prefix = "shipment-" + shipmentId + "-asset-";
    var suffix = shotSuffix(shotIndex);
    var budget = MAX_ATTACHMENT_FILENAME_LENGTH - prefix.length - suffix.length - EXTENSION.length;
    if (!ids.length)
        return toFileName("shipment-" + shipmentId, shotIndex);
    var joined = joinIdsWithinBudget(ids, budget);
    if (!joined)
        return toFileName("shipment-" + shipmentId, shotIndex);
    return "" + prefix + joined + suffix + EXTENSION;
};
export var buildReturnItemPhotoName = function (returnId, returnItemSeqId, shotIndex) {
    if (shotIndex === void 0) { shotIndex = 0; }
    return toFileName(returnItemSeqId ? "return-" + returnId + "-item-" + returnItemSeqId : "return-" + returnId, shotIndex);
};
export var blobToJpegFile = function (blob, fileName) {
    return new File([blob], fileName, { type: 'image/jpeg' });
};
/** Renames a file, keeping its original extension when the new name assumes .jpg. */
export var renameFile = function (file, fileName) {
    var _a;
    var originalExtension = (_a = file.name.match(/\.[a-z0-9]+$/i)) === null || _a === void 0 ? void 0 : _a[0];
    var name = originalExtension && !fileName.toLowerCase().endsWith(originalExtension.toLowerCase())
        ? fileName.replace(/\.[a-z0-9]+$/i, originalExtension)
        : fileName;
    return new File([file], name, { type: file.type || 'image/jpeg' });
};
